import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import type { UserType } from '@econtractor/types';
import { UserSelected } from 'modules/user';

const ReportExecutorSelect = () => {
    const { t } = useTranslation('Reports');
    const { values, setFieldValue } = useFormikContext<{ executor: UserType | null }>();
    return <UserSelected title={t('usersFields.user')} value={values.executor} onChange={(user) => void setFieldValue('executor', user)} clearable />;
};

export default ReportExecutorSelect;
